import * as actionTypes from '../actions/types';
import keyBy from 'lodash/keyBy';

const initialState = {
  idsToCouponCodeTypes: {},
};

const couponCodes = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.HYDRATE_COUPON_CODE_TYPES:
      return {
        ...state,
        idsToCouponCodeTypes: keyBy(action.couponCodeTypes, ({ id }) => id),
      };
    default:
      return state;
  }
};

export default couponCodes;
